import { Box, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import Logo from '../assets/logos/whatspro.gif';

export const LayoutAuth = ({ children }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={isMobile ? 'flex-start' : 'center'}
            alignItems={'center'}
            sx={{
                minHeight: '100vh',
                width: '100vw',
                backgroundColor: 'var(--background)',
                padding: isMobile ? '0' : '40px 0px',
                boxSizing: 'border-box',
            }}
        >
            <Box
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                sx={{
                    minHeight: isMobile ? '100vh' : '500px',
                    width: isMobile ? '100%' : '420px',
                    textAlign: 'center',
                    backgroundColor: 'var(--card)',
                    borderRadius: isMobile ? '0' : '16px',
                    border: isMobile ? 'none' : '1px solid var(--border)',
                    boxShadow: isMobile
                        ? 'none'
                        : '0 4px 12px -4px rgba(38, 34, 84, 0.13), 0 18px 40px -16px rgba(38, 34, 84, 0.22)',
                    overflow: 'hidden',
                    padding: 0,
                }}
            >
                {/* deck accent bar — thin brand gradient, used sparingly */}
                <Box
                    sx={{
                        height: '4px',
                        width: '100%',
                        flexShrink: 0,
                        background: 'linear-gradient(135deg, #0DA15A 0%, #0B241A 100%)',
                    }}
                />
                <Box
                    display={'flex'}
                    flexDirection={'column'}
                    alignItems={'center'}
                    sx={{
                        width: '100%',
                        padding: '40px 28px',
                        boxSizing: 'border-box',
                    }}
                    gap={2}
                >
                    <Box
                        component={'img'}
                        src={Logo}
                        sx={{
                            height: '84px',
                            width: '84px',
                            borderRadius: '16px',
                        }}
                    />
                    <Box
                        component={'form'}
                        display={'flex'}
                        flexDirection={'column'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        gap={1}
                        width={'100%'}
                    >
                        {children}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
